var map = {
	"./about/about1.svg": "70ea",
	"./about/about2.svg": "3b9c",
	"./about/json.svg": "deff",
	"./bell-green-border.svg": "0502",
	"./bell.svg": "ee6b",
	"./blue-dots.svg": "6ed0",
	"./book.svg": "c8e3",
	"./computer-happy.svg": "53a8",
	"./currencies/AFN.svg": "e390",
	"./currencies/ALL.svg": "29e6",
	"./currencies/ANG.svg": "3f79",
	"./currencies/AWG.svg": "e008",
	"./currencies/AZN.svg": "a664",
	"./currencies/BAM.svg": "11a7",
	"./currencies/BGN.svg": "ee63",
	"./currencies/BOB.svg": "3d86",
	"./currencies/BRL.svg": "8588",
	"./currencies/BTC.svg": "9a37",
	"./currencies/BWP.svg": "7c3d",
	"./currencies/BYN.svg": "3c79",
	"./currencies/BZD.svg": "5bde",
	"./currencies/CAD.svg": "60e1",
	"./currencies/CHF.svg": "8e63",
	"./currencies/CNY.svg": "92f1",
	"./currencies/CRC.svg": "2a4b",
	"./currencies/CUP.svg": "92b5",
	"./currencies/CZK.svg": "3d40",
	"./currencies/DKK.svg": "5c61",
	"./currencies/DOP.svg": "0424",
	"./currencies/EEK.svg": "96e3",
	"./currencies/ETH.svg": "030e",
	"./currencies/EUR.svg": "c429",
	"./currencies/GBP.svg": "f7fc",
	"./currencies/GHC.svg": "f1e6",
	"./currencies/GTQ.svg": "b57c",
	"./currencies/HNL.svg": "95ba",
	"./currencies/HRK.svg": "24e3",
	"./currencies/HUF.svg": "b0fe",
	"./currencies/IDR.svg": "7cdb",
	"./currencies/ILS.svg": "202b",
	"./currencies/INR.svg": "2f1f",
	"./currencies/IRR.svg": "0bdd",
	"./currencies/ISK.svg": "338e",
	"./currencies/JMD.svg": "d561",
	"./currencies/JPY.svg": "2cd3",
	"./currencies/KGS.svg": "2ec3",
	"./currencies/KHR.svg": "c144",
	"./currencies/KPW.svg": "0e9c",
	"./currencies/KRW.svg": "ce22",
	"./currencies/KZT.svg": "ff6f",
	"./currencies/LAK.svg": "7e94",
	"./currencies/LKR.svg": "379c",
	"./currencies/LTL.svg": "c7fd",
	"./currencies/LVL.svg": "308b",
	"./currencies/MKD.svg": "1868",
	"./currencies/MNT.svg": "3d34c",
	"./currencies/MUR.svg": "d886",
	"./currencies/MYR.svg": "e7ed",
	"./currencies/MZN.svg": "98ed",
	"./currencies/NGN.svg": "6e0f",
	"./currencies/NIO.svg": "f994",
	"./currencies/NOK.svg": "576d",
	"./currencies/NPR.svg": "aaab",
	"./currencies/OMR.svg": "4396",
	"./currencies/PAB.svg": "953e",
	"./currencies/PEN.svg": "18fa",
	"./currencies/PHP.svg": "591e",
	"./currencies/PKR.svg": "8189",
	"./currencies/PLN.svg": "e9fe",
	"./currencies/PYG.svg": "c05b",
	"./currencies/QAR.svg": "8e45",
	"./currencies/RON.svg": "f633",
	"./currencies/RSD.svg": "456f",
	"./currencies/RUB.svg": "84f0",
	"./currencies/SAR.svg": "9cc9",
	"./currencies/SCR.svg": "1770",
	"./currencies/SEK.svg": "27a4",
	"./currencies/SOS.svg": "1462",
	"./currencies/THB.svg": "e5b3",
	"./currencies/TRY.svg": "8094",
	"./currencies/TTD.svg": "bde6",
	"./currencies/TWD.svg": "dc4c",
	"./currencies/UAH.svg": "78b9",
	"./currencies/USD.svg": "6e5d",
	"./currencies/UYU.svg": "1a25",
	"./currencies/UZS.svg": "a7b8",
	"./currencies/VES.svg": "6268",
	"./currencies/VND.svg": "e4c9",
	"./currencies/XLM.svg": "8bd6",
	"./currencies/XRP.svg": "ae55",
	"./currencies/YER.svg": "dead",
	"./currencies/ZAR.svg": "4042",
	"./currencies/ZWL.svg": "ccf6",
	"./down-triangle-lines-gray.svg": "f695",
	"./down-triangle-lines-plus.svg": "9689",
	"./down-triangle-lines-white.svg": "72474",
	"./duplicate.svg": "8c42",
	"./email.svg": "9055",
	"./exclamation-blue.svg": "2b9a",
	"./exclamation.svg": "89ca",
	"./gear-gray.svg": "8fd9",
	"./gear.svg": "5cc9",
	"./green-check.svg": "4052",
	"./hamburger.svg": "eab1",
	"./info.svg": "07e6",
	"./left-arrow-blue.svg": "97d3",
	"./logout.svg": "309a",
	"./maintenance/XLM.svg": "000c",
	"./maintenance/XRP.svg": "9648",
	"./maintenance/blockchain.svg": "febf",
	"./my-filters-anon.svg": "6671",
	"./pause.svg": "ec7e",
	"./pencil-blue.svg": "8721",
	"./pencil.svg": "33bf",
	"./person.svg": "31af",
	"./phone.svg": "001e",
	"./play.svg": "5830",
	"./profile.svg": "b855",
	"./question.svg": "8bbe",
	"./red-x.svg": "f957",
	"./repeat.svg": "8180",
	"./right-arrow-black.svg": "2653",
	"./right-arrow.svg": "f590",
	"./search.svg": "51f2",
	"./trash-red.svg": "31f6",
	"./trash-white.svg": "aa5d",
	"./txs/account-sets-blue.svg": "c924",
	"./txs/account-sets-gray.svg": "5a43",
	"./txs/account-sets-white.svg": "841d",
	"./txs/all-blue.svg": "7947",
	"./txs/all-gray.svg": "50a2",
	"./txs/all-white.svg": "a6cb",
	"./txs/escrows-blue.svg": "0188",
	"./txs/escrows-gray.svg": "6fb0",
	"./txs/escrows-white.svg": "5c62",
	"./txs/nfts-blue.svg": "e51f",
	"./txs/nfts-gray.svg": "f273",
	"./txs/nfts-white.svg": "58d9",
	"./txs/offers-blue.svg": "cb6c",
	"./txs/offers-gray.svg": "c073",
	"./txs/offers-white.svg": "7f5a",
	"./txs/payment-channels-blue.svg": "cc5b",
	"./txs/payment-channels-gray.svg": "df0e",
	"./txs/payment-channels-white.svg": "66f9",
	"./txs/payments-blue.svg": "af47",
	"./txs/payments-gray.svg": "9b19",
	"./txs/payments-white.svg": "8666",
	"./txs/trust-lines-blue.svg": "abde",
	"./txs/trust-lines-gray.svg": "7c3b",
	"./txs/trust-lines-white.svg": "544f",
	"./x-black.svg": "0814",
	"./x-white.svg": "aac8",
	"./yellow-alert.svg": "7db9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";